import {
    selectDoc, selectArr, selectAll,
    event, removeClassAll, addClassAll,
    toggleClass, hasClass, ajax,
    removeClass, addClass, cartesian, isVisible
} from "../utils/utils";

import {addCartItem} from "../helpers/service.cart";

import {QuickView} from "./component.quickview";
import {Animate, lazyLoadShow} from "./component.animate";
import {MiniCart} from "./component.minicart";
import {clearFilter} from "../helpers/service.validator";
import {init3DViewAction} from "./component.productcard";
import {Modal} from "./component.modal";

let pcprops = {};

export const ajaxLoadProducts = (pcprops, recursive) => {
    ajax('GET', pcprops.next.getAttribute('href'))
        .then(function (response) {
            response = JSON.parse(response).response;
            pcprops.renderer.innerHTML = response;

            selectArr('#category-products .product', pcprops.renderer).map(newProduct => {
                pcprops.productsContainer.appendChild(newProduct)

                /**
                 * 3d view
                 */
                let cta3d = selectDoc('.view3d', newProduct)
                init3DViewAction(cta3d);

                if(selectDoc('#search')) {
                    /**
                     * Is Try-at-Home
                     */
                    let isTah = pcprops.mainCategory ? pcprops.mainCategory.value.includes('Try-At-Home') : false;

                    /**
                     * Add color buttons events
                     */
                    let btns = selectArr(('#' + newProduct.id + ' .color-variants button:not(.disabled)'))
                    btns.map(btn => {
                        event(btn, 'click', function () {
                            switchCardColor(newProduct.id, btn.getAttribute('data-color'), isTah)
                        })
                    });
                    switchCardColor(newProduct.id, 'default', isTah, false);

                    QuickView.init()
                }
            })

            pcprops.next = selectDoc('#load-more-next', pcprops.renderer);
            pcprops.renderer.innerHTML = '';
            pcprops.loadingMore = false;

            new Modal(false);

            recursive();
        })
}

/**
 *
 * @param productId
 * @param color
 * @param isTah
 * @param lazyload
 */
const switchCardColor = (productId, color, isTah = false, lazyload = true) => {
    let currentColors = selectArr(`#${productId} .color-variants button`);

    if (color === 'default') {
        let defaultColor = selectDoc(`#${productId} .color-variants button:not(.disabled).active`);
        if (!defaultColor) {
            defaultColor = selectDoc(`#${productId} .color-variants button:not(.disabled)`);
            if (!defaultColor) {
                defaultColor = selectDoc(`#${productId} .color-variants button`);
            }
        }
        color = defaultColor ? defaultColor.getAttribute('data-color') : '';
    }

    //Show current color
    removeClassAll(selectArr(`#${productId} .image img`), 'active');
    let allColorImages = [],
        allActiveColors = [];
    currentColors.map(btn => {
        let colorImages = selectArr(`#${productId} .image [data-color="${btn.getAttribute('data-color')}"]`)
        colorImages.map(colorImage => {
            if (btn.getAttribute('data-color') == color) {
                allActiveColors.push(colorImage);
                allActiveColors.push(btn);
                allColorImages.push(colorImages);

                // @ADA
                $('.template-collection').find(btn).attr('aria-pressed', 'true');
                $('.template-collection').find(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                $('.template-collection').find(btn).next('label').removeClass('d-none').addClass('d-block');
                $('.template-collection').find(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');

                let labels = selectArr(`#${productId} .current-color`)

                labels.map(label => {
                    if (label) {
                        if (isTah) {
                            label.innerText = color.replace('-', ' ').replace('gold', '');
                        } else {
                            label.innerText = color.replace('-', ' ');
                        }
                    }
                })
            }
        });
    });
    removeClassAll(currentColors, 'active')
    allColorImages.map(aci => {
        removeClassAll(aci, 'active')



    });
    allActiveColors.map(aac => {
        addClass(aac, 'active')
    });

    //Show default color
    if (!selectDoc(`#${productId} #colorImages img.content.active`)) {
        let firstColorImage = selectDoc(`#${productId} #colorImages img.content`);
        if (firstColorImage) {
            addClass(firstColorImage, 'active')
        } else {
            let firstImage = selectDoc(`#${productId} #colorImages img`);
            if (firstImage) {
                addClass(firstImage, 'active')
            }
        }
    }

    //Mobile drawer
    selectArr(`#${productId} .available-colors:not(.evented)`).map(availableColors => {
        if (availableColors) {
            addClass(availableColors, 'evented');

            let colorsContainer = selectArr(`#${productId} .color-variants`);

            const checkOutSideColorsMobile = async (e) => {
                selectArr(`#${productId} .color-variants.mobile-open`).map(openedColorsContainer => {
                    if (!openedColorsContainer.contains(e.target)) {
                        removeClass(openedColorsContainer, 'mobile-open')
                        window.removeEventListener('click', checkOutSideColorsMobile);
                    }
                })
            };

            event(availableColors, 'click', function () {
                addClassAll(colorsContainer, 'mobile-open')
                event(window, 'click', checkOutSideColorsMobile);
            });

            selectArr(`#${productId} .close-available-colors`).map(closeColorsContainer => {
                event(closeColorsContainer, 'click', function () {
                    removeClassAll(colorsContainer, 'mobile-open')
                    window.removeEventListener('click', checkOutSideColorsMobile);
                });
            });
        }
    })

    //Lazy load images
    if(lazyload) {
        selectArr(`#${productId} .lazy-load`).map(image => {
            lazyLoadShow(image)
        })
    }
}

const insertLifeStyleCards = (pcpProducts) => {
    if (pcpProducts) {
        /**
         * Clean current cards
         */
        selectArr('#pcp .lifestyle').map(card => {
            card.parentNode.removeChild(card);
        })

        if (pcpProducts.length >= 4) {
            /**
             * Re-add cards
             */
            const url = new URL(document.URL);
            pcprops.lifestyleCards.map(lifecard => {
                let position = parseInt(lifecard.getAttribute('data-pos')),
                    page = lifecard.getAttribute('data-page');

                if (page === url.pathname) {
                    if (pcpProducts.length < position) {
                        position = (pcpProducts.length + 1);
                    }

                    pcpProducts.map((product, index) => {
                        if ((index + 1) == (position - 1)) {
                            let newCard = lifecard.cloneNode(true);
                            product.parentNode.insertBefore(newCard, product.nextSibling);
                        }
                    })
                }
            })
        }
    }
}

const getLifeStyleCardsCount = () => {
    const url = new URL(document.URL);
    let count = 0;
    pcprops.lifestyleCards.map(lifecard => {
        let page = lifecard.getAttribute('data-page'),
            weight = lifecard.getAttribute('data-weight');

        if (page == url.pathname) {
            count += parseInt(weight)
        }
    })

    return count;
}

const initCollection = () => {
    try {
        if (pcprops.collectionProducts) {
            /**
             * Is Try-at-Home
             */
            let isTah = pcprops.mainCategory ? pcprops.mainCategory.value.includes('Try-At-Home') : false;

            /**
             * Process products
             */
            selectArr('#category-products .product:not(.colors-ready)').map((product) => {
                addClass(product, 'colors-ready')

                /**
                 * Add color buttons events
                 */
                let btns = selectArr(('#' + product.id + ' .color-variants button:not(.disabled)'))
                btns.map(btn => {
                    event(btn, 'click', function () {
                        switchCardColor(product.id, btn.getAttribute('data-color'), isTah)
                        $(btn).attr('aria-pressed', 'true');
                        $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('button').attr('aria-pressed', 'false');
                        $(btn).parent('.color-variants__item').siblings('.color-variants__item').children('label').removeClass('d-block').addClass('d-none');
                        $(btn).next().removeClass('d-none').addClass('d-block');
                    })
                    if ($(btn).hasClass("active")) {
                        $(btn).attr('aria-pressed', 'true');
                        $(btn).next().removeClass('d-none').addClass('d-block');
                    }
                });

                if(selectDoc('#search')) {
                    switchCardColor(product.id, 'default', isTah, false);
                }
            })

            QuickView.init()

            if (pcprops.firstTime) {
                /**
                 * Remove ajax
                 */
                pcprops.firstTime = false;
                pcprops.ajaxLoader ? addClass(pcprops.ajaxLoader, 'hide') : ''
                pcprops.productsContainer ? addClass(pcprops.productsContainer, 'show') : ''
                pcprops.filtersContainer ? addClass(pcprops.filtersContainer, 'show') : ''
                pcprops.tahContainer ? removeClass(pcprops.tahContainer, 'hide') : ''
            }

            updateFilters(isTah);

            Animate.lazyload();
              // @ada
              $(".product-card .image").each(function(){
                const hoverImage = $(this).find('.content.active').next('.color-img-hover').length;
                $(this).focusin(function () {
                    $(this).next('.quickview').css('opacity', '1');
                    $(this).find('.content.active').next('.color-img-hover').addClass('with-focus');
                    if(hoverImage > 0) {
                        $(this).find('.content.active').css('opacity', '0');
                    }
                });
                $(this).focusout(function () {
                    $(this).find('.content.active').css('opacity', '1');
                    $(this).find('.content.active').next('.color-img-hover').removeClass('with-focus');
                    $(this).next('.quickview').css('opacity', '0');
                });
            });
        
            $(".product-card .quickview").each(function(){
                $(this).focusin(function () {
                    $(this).css('opacity', '1');
                });
                $(this).focusout(function () {
                    $(this).css('opacity', '0');
                });
            });
        
        }
    } catch (e) {
        pcprops.productsContainer.classList.add('show')
        pcprops.filtersContainer.classList.add('show')
        console.log('Error fetching collection data.', e)
    }
}

const lazyLoadProducts = () => {
    pcprops.loadingMore = true;
    if (pcprops.next) {
        ajaxLoadProducts(pcprops, lazyLoadProducts);
    } else {
        let filteredProducts = selectArr(('#category-products .product:not(.disabled):not(.hide-d)'));
        pcprops.productsTotal.innerHTML = `${filteredProducts.length} Results <span class="slash">/</span>`
        pcprops.collectionProducts = selectArr('#category-products .product');
        initCollection()
    }
}

const initActions = () => {
    $(".quickview").each(function(){
        $(this).focusin(function () {
            $(this).css('opacity', '1')
          });
          $(this).focusout(function () {
            $(this).css('opacity', '0')
          });
    });
    event(props.goUp, 'click', function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    })

    let lastScrollTop = 0;
    event(window, 'scroll', function () {
        /**
         * Go up
         */
        if (window.scrollY > 300) {
            addClass(pcprops.goUp, 'show')
        } else {
            removeClass(pcprops.goUp, 'show')
        }
        let footerTop = pcprops.footer.getBoundingClientRect().top;
        if (footerTop < 1200) {
            removeClass(pcprops.goUp, 'show')
        }

        /**
         * Fixed filters bar
         */
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            //Scroll down
            if (window.scrollY > 600) {
                removeClass(pcprops.filtersContainer, 'fixedUp')
                addClass(pcprops.filtersContainer, 'fixed')
            } else {
                removeClass(pcprops.filtersContainer, 'fixedUp')
                removeClass(pcprops.filtersContainer, 'fixed')
            }
        } else {
            //Scroll up
            if (window.scrollY > 600) {
                removeClass(pcprops.filtersContainer, 'fixed')
                addClass(pcprops.filtersContainer, 'fixedUp')
            } else {
                removeClass(pcprops.filtersContainer, 'fixedUp')
                removeClass(pcprops.filtersContainer, 'fixed')
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
    })

    if (pcprops.refine) {
        event(pcprops.applyRefine, 'click', function () {
            let close = selectDoc('.close-modal', pcprops.refineModal);
            close ? close.click() : '';

            pcprops.selectedFilters.innerHTML = '';
            updateFilters(false, true);

            pcprops.attributesArray.map(attribute => {
                if (pcprops.attribute[attribute.id]) {
                    let filter = document.createElement('div');
                    filter.className = 'filter body3 body3-left';
                    filter.setAttribute('data-f', attribute.id)
                    filter.innerHTML = clearFilter(attribute.id);
                    pcprops.selectedFilters.appendChild(filter)

                    /**
                     * Remove filter event
                     */
                    event(filter, 'click', function () {
                        pcprops.attribute[this.getAttribute('data-f')] = false;
                        pcprops.selectedFilters.removeChild(filter)
                        selectDoc('#' + this.getAttribute('data-f')).classList.remove('active')
                        selectDoc('#' + this.getAttribute('data-f') + ' button').classList.remove('active')

                        if (pcprops.selectedFilters.childElementCount < 1) {
                            pcprops.selectedFiltersContainer.classList.remove('active');
                            pcprops.selectedFilters.innerHTML = '';
                            pcprops.currentAttribute.innerHTML = '(0)'
                        } else {
                            pcprops.currentAttribute.innerHTML = `(${pcprops.selectedFilters.childElementCount})`
                        }

                        updateFilters(false, true);
                    })
                }
            })

            if (pcprops.selectedFilters.innerHTML !== '') {
                pcprops.selectedFiltersContainer.classList.add('active');
            }
        })
    }
}

const generateCartesianFilter = (collections, materials, gemstones, diamonds, occasions, styles, colors) => {
    let cartesianArray = [];

    if (collections.length > 0) {
        cartesianArray.push(collections.map(a => clearFilter(a)))
    }

    if (materials.length > 0) {
        cartesianArray.push(materials.map(a => clearFilter(a)))
    }

    if (gemstones.length > 0) {
        cartesianArray.push(gemstones.map(a => clearFilter(a)))
    }

    if (diamonds.length > 0) {
        cartesianArray.push(diamonds.map(a => clearFilter(a)))
    }

    if (occasions.length > 0) {
        cartesianArray.push(occasions.map(a => clearFilter(a)))
    }

    if (styles.length > 0) {
        cartesianArray.push(styles.map(a => clearFilter(a)))
    }

    if (colors.length > 0) {
        cartesianArray.push(colors.map(a => clearFilter(a)))
    }

    if (cartesianArray.length > 0) {
        return cartesian(...cartesianArray);
    } else {
        return null;
    }
}

const filterCartesianProducts = (currentProducts, attributeAll, preview, isTah, specific = null) => {
    let previewResults = 0;

    //Generate current cartesian array
    let collections = []
        , materials = []
        , gemstones = []
        , diamonds = []
        , occasions = []
        , styles = []
        , colors = []
    ;

    pcprops.attributesArray.map(attribute => {
        if (pcprops.attribute[attribute.id]) {
            switch (attribute.parent) {
                case 'opts-collections':
                    collections.push(attribute.id)
                    break;
                case 'opts-material':
                    materials.push(attribute.id)
                    break;
                case 'opts-gemstone':
                    gemstones.push(attribute.id)
                    break;
                case 'opts-diamond':
                    diamonds.push(attribute.id)
                    break;
                case 'opts-occasion':
                    occasions.push(attribute.id)
                    break;
                case 'opts-style':
                    styles.push(attribute.id)
                    break;
                case 'opts-colors':
                    colors.push(attribute.id)
                    break;
            }
        }
    });

    if (specific) {
        switch (specific.parentNode.id) {
            case 'opts-collections':
                collections.push(specific.id)
                break;
            case 'opts-material':
                materials.push(specific.id)
                break;
            case 'opts-gemstone':
                gemstones.push(specific.id)
                break;
            case 'opts-diamond':
                diamonds.push(specific.id)
                break;
            case 'opts-occasion':
                occasions.push(specific.id)
                break;
            case 'opts-style':
                styles.push(specific.id)
                break;
            case 'opts-colors':
                colors.push(specific.id)
                break;
        }
    }

    let cartesianFilters = generateCartesianFilter(collections, materials, gemstones, diamonds, occasions, styles, colors);
    currentProducts.map((product) => {
        if (product.id) {
            /**
             * Filter color
             */
            if (!preview) {
                switchCardColor(product.id, pcprops.color, isTah, false);
            }

            /**
             * Filter attribute
             */
            previewResults++;

            !preview ? product.classList.remove('hide-d') : '';

            if (cartesianFilters) {
                if (!attributeAll && cartesianFilters.length > 0) {
                    let show = false;

                    cartesianFilters.map(cartesianFilter => {
                        if (!pcprops.productsCartesians[product.id]) {
                            let productAttributes = JSON.parse(product.getAttribute('data-attribute')),

                                productColl = productAttributes[0].split('|').filter(String),
                                productMaterials = productAttributes[1].split('|').filter(String),
                                productGems = productAttributes[2].split('|').filter(String),
                                productDiamonds = productAttributes[3].split('|').filter(String),
                                productOccasions = productAttributes[4].split('|').filter(String),

                                productStyles = productAttributes[5].split('|').filter(String)
                                    .concat(productAttributes[6].split('|').filter(String)
                                        .concat(productAttributes[7].split('|').filter(String)
                                            .concat(productAttributes[8].split('|').filter(String)))),

                                productColors = productAttributes[9].split('|').filter(String);

                            pcprops.productsCartesians[product.id] = generateCartesianFilter(productColl, productMaterials, productGems, productDiamonds, productOccasions, productStyles, productColors);
                        }

                        pcprops.productsCartesians[product.id].map(productFilters => {

                            if (!Array.isArray(productFilters)) {
                                productFilters = [productFilters];
                            }

                            if (!Array.isArray(cartesianFilter)) {
                                cartesianFilter = [cartesianFilter];
                            }

                            let intersection = cartesianFilter.filter(cf => productFilters.includes(clearFilter(cf)));
                            if (intersection.length === cartesianFilter.length) {
                                show = true;
                            }
                        })
                    });

                    if (!show) {
                        if (preview) {
                            previewResults--;
                        } else {
                            product.classList.add('hide-d')
                        }
                    }
                }
            }

            !preview ? pcprops.productsContainer.appendChild(product) : '';
        }
    });

    return previewResults;
}

const updateFilters = (isTah = false, results = false, preview = false, lastFilter = null) => {
    if(selectDoc('#search')) {
        return;
    }

    let currentProducts = selectArr('.product', pcprops.productsContainer);

    // Check if any selected or not
    let attributeAll = true;
    pcprops.attributesArray.map(attribute => {
        if (pcprops.attribute[attribute.id]) {
            attributeAll = false;
        }
    });

    let totalResults = filterCartesianProducts(currentProducts, attributeAll, preview, isTah)

    //Total results && lifestyle
    let filteredProducts = selectArr(('#category-products .product:not(.disabled):not(.hide-d)'));

    insertLifeStyleCards(filteredProducts);

    if (results) {
        pcprops.productsTotal.innerHTML = `${filteredProducts.length} Results<span class="slash">/</span>`

        //Show no results module
        let pcpImgCopySection = selectDoc('#section-pcp-image-copy');
        if (pcpImgCopySection) {
            let pcpImgCopySectionResults = selectArr('.col.results', pcpImgCopySection),
                pcpImgCopySectionNoResults = selectArr('.col.no-results', pcpImgCopySection)
            if (filteredProducts.length < 1) {
                addClassAll(pcpImgCopySectionResults, 'hide')
                removeClassAll(pcpImgCopySectionNoResults, 'hide')
            } else {
                addClassAll(pcpImgCopySectionNoResults, 'hide')
                removeClassAll(pcpImgCopySectionResults, 'hide')
            }
        }
    }

    if (preview) {
        if (!attributeAll) {
            pcprops.previewProductsTotal.innerHTML = `${totalResults} Results`;
        } else {
            pcprops.previewProductsTotal.innerHTML = ``;
        }

        setTimeout(function () {
            selectArr(`.attribute-filter:not(.hide)`).map(col => {
                let colOptions = selectDoc('.options', col);
                if (colOptions) {
                    if (lastFilter.parentNode.id !== colOptions.id) {
                        removeClassAll(selectArr('.opt', col), 'no-results');
                        //Filter not selected options against current selected combinations
                        let notSelectedOptions = selectArr('button:not(.active)', col);
                        notSelectedOptions.map(nso => {
                            let nsoPreviewResults = filterCartesianProducts(currentProducts, attributeAll, preview, isTah, nso.parentNode);
                            if (nsoPreviewResults < 1) {
                                addClass(nso.parentNode, 'no-results')
                            }
                        });
                    }
                }
            })
        }, 100);
    } else {
        pcprops.previewProductsTotal.innerHTML = ``
    }
}

const initFilters = () => {
    pcprops.refineColors.map(color => {
        event(color, 'click', function () {
            pcprops.color = this.id === 'default' ? 'white-gold' : this.id

            removeClassAll(pcprops.refineColors, 'active');
            removeClassAll(pcprops.refineColorsBtns, 'active');

            let btn = selectArr('#color #' + color.id + ' button')
            addClassAll(btn, 'active');
            btn.map(b => {
                addClass(b.parentNode, 'active')
            })

            updateFilters();
        });
    });

    pcprops.refineAttributes.map(refineAttribute => {
        event(refineAttribute, 'click', function () {
            if (!hasClass(refineAttribute, 'no-results')) {
                let btn = selectDoc('#' + refineAttribute.id + ' button', refineAttribute);

                //Radio options
                if (hasClass(btn, 'radio')) {
                    selectArr('div .opt', refineAttribute.parentNode.parentNode)
                        .map(opt => {
                            let radioBtn = selectDoc('button.radio', opt);
                            if (radioBtn) {
                                removeClass(radioBtn, 'active')
                                pcprops.attribute[opt.id] = false;
                            }
                        })
                }

                //Toggle status
                toggleClass(btn, 'active')
                pcprops.attribute[refineAttribute.id] = hasClass(btn, 'active');

                //Update total summary count
                let chosen = [];
                pcprops.currentAttribute = selectDoc('.title .option', refineAttribute.parentNode.parentNode);
                pcprops.attributesArray.map(attribute => {
                    if (pcprops.attribute[attribute.id] && (refineAttribute.parentNode.id === attribute.parent)) {
                        chosen.push(attribute);
                    }
                })
                pcprops.currentAttribute.innerHTML = chosen.length < 1 ? '(0)' : `(${chosen.length})`;

                //Bind gemstone material with gemstone type column
                if (refineAttribute.parentNode.id === 'opts-material') {
                    let isGemstoneSelected = selectDoc('.opt#gemstone button.active'),
                        gemstoneType = selectDoc('#gemstone-type-filter'),

                        isNoGemstoneSelected = selectDoc('.opt#no_gems button.active'),
                        selectedMaterials = selectArr('#opts-material .opt button.active'),
                        diamondShape = selectDoc('#diamond-shape-filter'),

                        hiddenFilters = [];

                    removeClass(gemstoneType, 'hide')
                    if (gemstoneType) {
                        if (!isGemstoneSelected) {
                            hiddenFilters.push(gemstoneType);
                            addClass(gemstoneType, 'hide')
                        }
                    }

                    removeClass(diamondShape, 'hide')
                    if (isNoGemstoneSelected) {
                        if (selectedMaterials.length === 1) {
                            hiddenFilters.push(diamondShape);
                            addClass(diamondShape, 'hide')
                        }
                    }

                    //Clear old selected options
                    hiddenFilters.map(hiddenFilter => {
                        selectArr('div .opt', hiddenFilter)
                            .map(opt => {
                                let btn = selectDoc('button', opt);
                                if (btn) {
                                    removeClass(btn, 'active')
                                    pcprops.attribute[opt.id] = false;
                                }
                            });

                        let countSummary = selectDoc('.title .option', hiddenFilter);
                        countSummary.innerHTML = '(0)';
                    })
                }

                //Bind product type to style type
                if (refineAttribute.parentNode.id === 'opts-collections') {
                    pcprops.styleFilterTitle ? pcprops.styleFilterTitle.innerHTML = `${refineAttribute.id === 'Earring' ? 'Earrings' : refineAttribute.id} Style:` : '';
                    addClassAll(pcprops.styleFilterOpts, 'hide')
                    removeClassAll(selectArr(`.attribute-filter#style-filter .opt.${refineAttribute.id}`), 'hide')

                    let styleOpts = selectArr('.attribute-filter#style-filter .opt button');
                    selectArr('.attribute-filter#style-filter .option').map(title => {
                        title.innerHTML = '(0)';
                    })
                    removeClassAll(styleOpts, 'active')
                    pcprops.attributesArray.map(attribute => {
                        styleOpts.map(styleOpt => {
                            if (styleOpt.parentNode.id === attribute.id) {
                                pcprops.attribute[attribute.id] = false
                            }
                        })
                    })
                }

                updateFilters(false, false, true, refineAttribute);
            }
        })
    })

    pcprops.clearFilters.map(clear => {
        event(clear, 'click', function () {
            /** Clear secondary filters **/
            selectArr('.attribute-filter .option').map(title => {
                title.innerHTML = '(0)';
            })
            removeClassAll(selectArr('.attribute-filter .opt button'), 'active')
            removeClassAll(selectArr('.attribute-filter .opt'), 'no-results')
            pcprops.attributesArray.map(attribute => {
                pcprops.attribute[attribute.id] = false
            })
            pcprops.selectedFiltersContainer.classList.remove('active');
            pcprops.selectedFilters ? pcprops.selectedFilters.innerHTML = '' : '';

            /** Clear colors **/
            selectArr('.product', pcprops.productsContainer).map(product => {
                switchCardColor(product.id, 'default', false, false);
            });

            updateFilters(false, true);
        })
    })
}

const keepsakeBox = () => {
    if (pcprops.bagBtn) {
        event(pcprops.bagBtn, 'click', function () {
            MiniCart.toggleOverlay();
            addCartItem(pcprops.bagId.value, 1, {
                'name': 'Keepsake Box',
                'id': pcprops.bagId.value,
                'price': selectDoc('#bag-btn .price').innerText,
                'quantity': 1,
            }).then(
                function (response) {
                    response = JSON.parse(response);
                    if (response.status === 200) {
                        MiniCart.redirect()
                    } else {
                        console.log('Error adding to cart!');
                    }
                })
        })
    }
}

const props = () => {
    pcprops = {
        firstTime: true,
        pageContainer: selectDoc('#PageContainer'),
        mainCategory: selectDoc('#category-tag'),
        headerContainer: selectDoc('#pcp #header'),
        productApi: "/products",
        productsContainer: selectDoc('#category-products'),
        productsTotal: selectDoc('#total-products .total'),
        previewProductsTotal: selectDoc('#preview-total-results'),
        categorySubcategories: selectDoc('#subcategories-tab'),

        goUp: selectDoc('#go-up'),
        footer: selectDoc('footer'),
        loadMore: selectDoc('#load-more'),
        refine: selectDoc('#refine-category'),
        applyRefine: selectDoc('#apply-refine'),

        refineModal: selectDoc('#refine-modal'),
        modalTabs: selectArr('#refine-modal .title'),

        refineColors: selectArr('#color .options .opt'),
        refineColorsBtns: selectArr('#color .options button'),
        currentColor: selectDoc('#color .title .option'),
        color: 'default',
        firstColor: selectDoc('#color .opt'),

        attribute: {},
        attributesArray: [],

        filtersContainer: selectDoc('#filters-container'),
        clearFilters: selectArr('button.clear-filters'),
        selectedFilters: selectDoc('#selected-filters .filters'),
        selectedFiltersContainer: selectDoc('#selected-filters'),

        styleFilter: selectDoc('.attribute-filter#style-filter'),
        styleFilterOpts: selectArr('.attribute-filter#style-filter .opt'),
        styleFilterTitle: selectDoc('.attribute-filter#style-filter .title strong'),

        ajaxLoader: selectDoc('#ajax-loader'),
        tahContainer: selectDoc('#section-pcp-image-copy'),

        lifestyleCards: selectArr('#life-style-cards .lifestyle'),
        lifestyleCount: 0,
        customerId: selectDoc('#customerId'),

        firstClick: false,

        bagBtn: selectDoc('#bag-btn'),
        bagId: selectDoc('#bag-id'),

        collectionProducts: selectArr('#category-products .product'),
        loadingMore: false,
        next: selectDoc('#load-more-next'),
        renderer: selectDoc('#load-more-products'),

        productsCartesians: []
    }
}

const initializer = () => {
    props();
    /**
     * Init filters
     */
    let currentProducts = selectArr('.product', pcprops.productsContainer);
    if (!pcprops.collectionsFiltersReady) {
        let collectionsFilters = [];
        pcprops.collectionsFiltersReady = true;
        currentProducts.map((product) => {
            if (product.id) {
                let productAttributes = JSON.parse(product.getAttribute('data-attribute')),
                    colls = productAttributes[4].split('|').filter(String);
                collectionsFilters = collectionsFilters.concat(colls);
            }
        });
    }

    pcprops.attributesArray = [];
    pcprops.refineAttributes = selectArr('.attribute-filter .options .opt')

    selectArr('.attribute-filter .opt').map(opt => {
        pcprops.attributesArray.push({
            id: opt.id,
            parent: opt.parentNode.id
        })
    })

    pcprops.refineAttributes.map(refineAttribute => {
        pcprops.attribute[refineAttribute.id] = false;
    })

    pcprops.lifestyleCount = getLifeStyleCardsCount();

    if(!selectDoc('#search')) {
        initActions();
        initFilters();
    }

    initCollection();
    keepsakeBox();
    lazyLoadProducts();
}

export const PCP = {
    init: () => initializer(),
    switchCardColor: (id, color, isTah = false, lazyload = true) => switchCardColor(id, color, isTah, lazyload)
}
